const learn = {
  header: 'Aprenda + Gane',
  header_title: 'Cursos disponibles',
  header_subtitle: '¡Descubra información útil al ganar dinero!',
};

export default learn;
